import dynamic from "next/dynamic";
const ImageWithParagraphGridComponent = dynamic(()=>import("./image-with-paragraph-grid-component"));
import ImageWithParagraphGridConfig from "./image-with-paragraph-grid-config";
import ImageWithParagraphGridAdvancedConfig from "./image-with-paragraph-grid-advanced-config";
export default {
    ImageWithParagraphGridComponent,
    ImageWithParagraphGridConfig,
    ImageWithParagraphGridAdvancedConfig
};
